import React from 'react';

const AWS_Shared_Responsibility = () => {
  return (
    <div>
      <h1>AWS_Shared_Responsibility</h1>
      <p>This is the AWS_Shared_Responsibility component.</p>
    </div>
  );
};

export default AWS_Shared_Responsibility;
